import { render, staticRenderFns } from "./ResumePerProducts.vue?vue&type=template&id=0b933783&scoped=true"
import script from "./ResumePerProducts.vue?vue&type=script&lang=js"
export * from "./ResumePerProducts.vue?vue&type=script&lang=js"
import style0 from "./ResumePerProducts.vue?vue&type=style&index=0&id=0b933783&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b933783",
  null
  
)

export default component.exports